import { blocks, customization } from '@yola/ws-sdk';

const restoreOptions = (destinationBlockNode, options = []) => {
  const blockId = blocks.accessors.getBlockIdByElement(destinationBlockNode);
  const currentPalette = customization.accessors.getCurrentColorPalette();
  const destinationBlockSettings = blocks.accessors.getBlockSettings(blockId, currentPalette);

  (destinationBlockSettings.displayOptions || []).forEach((destinationOption) => {
    if (!options.includes(destinationOption.id)) return;

    const { value, values, querySelector, attribute } = destinationOption;

    if (!value && !values) return;

    const defaultValue = value || values[values.length - 1];
    if (!defaultValue) return;

    const nodes = querySelector
      ? [...destinationBlockNode.querySelectorAll(querySelector)]
      : [destinationBlockNode];
    nodes.forEach((node) => {
      node.setAttribute(attribute, defaultValue);
    });
  });
};

export default restoreOptions;
